import Icon from '../components/Icon.vue'

Icon.register({
  'skull-crossbones': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M439.1 453.1c7.9 4 11.1 13.6 7.2 21.5l-14.3 28.6c-4 7.9-13.6 11.1-21.5 7.1l-186.5-90.7-186.5 90.7c-7.9 4-17.5 0.8-21.5-7.1l-14.3-28.6c-4-7.9-0.8-17.5 7.1-21.5l142-69.1-142-69.1c-7.9-4-11.1-13.6-7.1-21.5l14.3-28.6c4-7.9 13.6-11.1 21.5-7.2l186.5 90.7 186.5-90.7c7.9-4 17.5-0.7 21.5 7.2l14.3 28.6c4 7.9 0.8 17.5-7.1 21.5l-142 69.1zM150 237.3c-41.8-22.4-70-62.8-70-109.3 0-70.7 64.5-128 144-128s144 57.3 144 128c0 46.5-28.2 86.9-70 109.3l5.5 25.9c2.7 12.6-5.4 24.8-16.5 24.8h-126.1c-11 0-19.1-12.2-16.5-24.8zM280 112c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM168 112c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skull-crossbones.js
// module id = 1900
// module chunks = 0